<script setup lang="ts">
import type { ISchoolGradeDisplayConfiguration } from '@/core/school-grades/schoolGrade.types';
import type { Components } from '@/api/generated/api';
import AssessmentRatingInput from '@/core/performanceAssessments/AssessmentRatingInput.vue';

const emit = defineEmits<{
  'update:value': [value: number | null];
}>();

const props = defineProps<{
  gradeConfiguration: ISchoolGradeDisplayConfiguration | null;
  performanceAssessment: Components.Schemas.PerformanceAssessmentDto;
  value: number | null;
}>();
</script>

<template>
  <div class="flex max-sm:flex-wrap items-center justify-between gap-md px-md py-sm">
    <span
      class="min-w-0 truncate"
      :class="props.value === null ? 'text-base font-normal text-secondary' : 'text-heading-semibold text-primary'"
    >
      {{
        $t(props.value === null ? 'performanceAssessmentEntry.unratedLabel' : 'performanceAssessmentEntry.ratingLabel')
      }}
    </span>
    <AssessmentRatingInput
      :key="props.performanceAssessment.id"
      :grade-configuration="gradeConfiguration"
      :accessible-label="$t('performanceAssessmentEntry.ratingLabel')"
      :model-value="props.value"
      :assessment="props.performanceAssessment"
      @update:model-value="emit('update:value', $event)"
    />
  </div>
</template>
